import React from "react";

import { PitchInformationAskForXboxDataType } from "../../../../models/forms";
import { FundingSoughtOptions } from "../../../../models/pitchUxModels";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyPitchAskForXboxProps = {
  dataInForm: PitchInformationAskForXboxDataType;
};

const fundingSoughtOptionsMap = new Map<string, string>([
  [FundingSoughtOptions.Yes, "yes"],
  [FundingSoughtOptions.No, "no"],
  [FundingSoughtOptions.Other, "other"],
]);

const PitchAskForXboxConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "fundingSought",
    {
      title: "pitchAskForXboxFundingSoughtTitle",
      mapper: (data: PitchInformationAskForXboxDataType, localizedStrings: Map<string, string>) =>
        localizedStrings.get(fundingSoughtOptionsMap.get(data.fundingSought) ?? ""),
    },
  ],
  ["fundingSoughtDetails", { title: "pitchAskForXboxFundingSoughtDetailsTitle" }],
  ["otherSupportNeeded", { title: "pitchAskForXboxOtherSupportNeededTitle" }],
]);

export const ReadOnlyPitchAskForXbox = ({ dataInForm }: ReadOnlyPitchAskForXboxProps) => {
  const extraStringsToLocalize = ["yes", "no", "other"];
  return (
    <ReadOnlyForm
      formConfig={PitchAskForXboxConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
